import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {useMemo} from 'react'

type WidgetData = {
  code: string
}

export const useTrustBlockWidgets = (prefix: string): WidgetData[] | null => {
  const variations = EnvironmentProvider.useVariations()

  const widgetsData = useMemo(() => {
    const widgetsData: WidgetData[] = []
    
    const hasExactMatch = variations?.conditions?.[prefix] && variations?.widgets?.[prefix]
    
    const usedWidgetCodes = Object.keys(variations?.conditions ?? {}).filter(
      (code) => {
        if (hasExactMatch) {
          return code === prefix
        }
        return code === prefix || code.startsWith(`${prefix}:`)
      }
    )

    for (const widgetCode of usedWidgetCodes) {
      const conditionConfig = variations?.conditions[widgetCode]

      if (!Boolean(conditionConfig)) {
        continue
      }

      widgetsData.push({
        code: widgetCode,
      })
    }

    return widgetsData
  }, [variations, prefix])

  if (!variations) {
    return null
  }

  return widgetsData
}
